// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { Formik, Form, Field, useFormikContext } from "formik";
// import InputLayout from "../../../../atoms/InputLayout";
// import * as Yup from "yup";
// import Error from "../../../../atoms/Error";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import CheckboxWrapper from "../../../../atoms/CheckBoxWrapper/Checkbox";
// import "./style.scss";
// import { postData, patchData, putData, getData } from "../../../../../services";
// import { useCookies } from "react-cookie";
// import toast from "react-hot-toast";
// import {
//   confimationStyles,
//   errorStyles,
// } from "../../../../../assets/styles/toast";
// // Custom hook to access Formik context
// const useFormikFieldUpdate = () => {
//   const { setFieldValue } = useFormikContext();
//   return { setFieldValue };
// };

// const RoleManagement = ({ onClose, onSubmit, initialData, refetchData }) => {
//   const [cookies] = useCookies(["e_t"]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [permissionsData, setPermissionsData] = useState();

//   // Base permissions structure
//   const basePermissions = {
//     Home: { view: false, addEdit: false, export: false, delete: false },
//     "Employee Management": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     "Team Management": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     Projects: { view: false, addEdit: false, export: false, delete: false },
//     Tasks: { view: false, addEdit: false, export: false, delete: false },
//     Reports: { view: false, addEdit: false, export: false, delete: false },
//     "Client Management": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     "Role Management": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     "Business Segment": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     "Department": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//     "Notifications": {
//       view: false,
//       addEdit: false,
//       export: false,
//       delete: false,
//     },
//   };

//   const [initialValues, setInitialValues] = useState({
//     role_Name: initialData?.role_name || "",
//     permissions: basePermissions,
//   });

//   // Transform API data to match form structure
//   const getInitialPermissions = useCallback(() => {
//     if (!permissionsData || !initialData?.role_id) return basePermissions;

//     const updatedPermissions = { ...basePermissions };

//     permissionsData.forEach((permission) => {
//       const module = permission.module;
//       if (updatedPermissions[module]) {
//         updatedPermissions[module] = {
//           view: permission.is_view,
//           addEdit: permission.is_create || permission.is_edit,
//           export: permission.is_export, // Not present in API response, keeping as false
//           delete: permission.is_delete,
//         };
//       }
//     });

//     return updatedPermissions;
//   }, [permissionsData, initialData?.role_id]);

//   useEffect(() => {
//     if (permissionsData) {
//       setInitialValues({
//         role_Name: initialData?.role_name || "",
//         permissions: getInitialPermissions(),
//       });
//     }
//   }, [permissionsData, initialData?.role_id, getInitialPermissions]);

//   // const initialValues = {
//   //   role_Name: initialData?.role_name || "",
//   //   permissions: getInitialPermissions(),
//   // };

//   const disabledPermissionsConfig = {
//     Home: ["export", "addEdit", "delete"],
//     "Employee Management": ["export"], // Match new key
//     "Team Management": ["export"], // Match new key
//     Reports: ["addEdit" , "delete"],
//     "Client Management" : ["export"],
//     "Role Management" : ["export"],
//     "Business Segment" : ["export"],
//     "Department" : ["export"],
//     'Notifications' : ['export', 'delete']
//   };

//   const isPermissionDisabled = (module, permission) => {
//     return disabledPermissionsConfig[module]?.includes(permission) || false;
//   };

//   const modules = Object.keys(basePermissions);

//   const transformPermissions = (permissions) => {
//     return Object.entries(permissions).map(([module, perms]) => ({
//       module,
//       create_teams: module === "TeamManagement" ? perms.addEdit : false,
//       assign_task: module === "Tasks" ? perms.addEdit : false,
//       is_create: perms.addEdit,
//       is_edit: perms.addEdit,
//       is_delete: perms.delete,
//       is_view: perms.view,
//       is_export : perms.export,
//       }));
//   };

//   const handlePermissions = useCallback(async () => {
//     if (!initialData?.role_id) return;

//     try {
//       const res = await getData({
//         endpoint: "Role/role/getAccessByRole_id",
//         params: {
//           roleId: initialData.role_id,
//         },
//         token: cookies.e_t,
//       });

//       if (res) {
//         setPermissionsData(res?.data);
//       }
//     } catch (err) {
//       console.error("Error fetching permissions:", err);
//     }
//   }, [cookies.e_t, initialData?.role_id]);

//   const handleFormSubmit = async (values, { resetForm }) => {
//     setIsSubmitting(true);
//     const transformedPermissions = transformPermissions(values.permissions);

//     try {
//       const res = await postData({
//         endpoint: "Role/AddAccessesToRole",
//         data: transformedPermissions,
//         token: cookies.e_t,
//         params: {
//           role_name: values.role_Name,
//           created_by: cookies.euid,
//         },
//       });

//       if (res) {
//         toast.success("Role created successfully", {
//           style: confimationStyles,
//         });
//         setIsSubmitting(false);
//         onClose();
//         refetchData();
//         onSubmit({
//           role_name: values.role_Name,
//           permissions: transformedPermissions,
//         });
//       }
//     } catch (err) {
//       // console.error("Submission error:", err);
//       // toast.error("Failed to create role", { style: errorStyles });
//       setIsSubmitting(false);
//     }
//   };

  

//   const handleFormEdit = async (values) => {
//     setIsSubmitting(true);
//     const transformedPermissions = transformPermissions(values.permissions);

//     try {
//       const res = await patchData({
//         endpoint: "Role/EditAccessesToRole",
//         data: transformedPermissions,
//         token: cookies.e_t,
//         params: {
//           role_id: initialData?.role_id,
//           modified_by: cookies.euid,
//           role_name: values?.role_Name,
//         },
//       });

//       if (res) {
//         toast.success("Updated successfully", {
//           style: confimationStyles,
//         });
//         setIsSubmitting(false);
//         onClose();
//         refetchData();
//         onSubmit({
//           role_name: values.role_Name,
//           permissions: transformedPermissions,
//         });
//       }
//     } catch (err) {
//       // console.error("Submission error:", err);
//       // toast.error("Failed to create role", { style: errorStyles });
//       setIsSubmitting(false);
//     }
//   };

//   useEffect(() => {
//     handlePermissions();
//   }, [handlePermissions]);

//   return (
//     <div className="role-management-container">
//       <Formik
//         initialValues={initialValues}
//         // onSubmit={handleFormSubmit}
//         onSubmit={(values, { resetForm }) => {
//           if (initialData) {
//             handleFormEdit(values);
//           } else {
//             handleFormSubmit(values, { resetForm });
//           }
//         }}
//         validateOnChange={true}
//         validateOnBlur={true}
//         enableReinitialize={true} // This ensures form reinitializes when initialValues change
//       >
//         {({ values, setFieldValue, errors, dirty, isValid }) => (
//           <Form className="role-form">
//             <div className="form-group">
//               <label htmlFor="role_Name">Role</label>
//               <InputLayout>
//                 <Field name="role_Name" />
//                 <Error error={errors.role_Name} />
//               </InputLayout>
//             </div>
//             <table className="permissions-table">
//               <thead>
//                 <tr>
//                   <th>Module Name</th>
//                   <th>

//                   <div className={`checkbox_container`}>
//                   <label htmlFor=""  className="fw-normal"> View</label>
//                     <CheckboxWrapper
//                       type="checkbox"
//                       name="masterView"
//                       checked={modules.every((module) => {
//                         if (isPermissionDisabled(module, "view")) return true;
//                         return values.permissions[module].view;
//                       })}
//                       onChange={(e) => {
//                         const newValue = e.target.checked;
//                         modules.forEach((module) => {
//                           if (!isPermissionDisabled(module, "view")) {
//                             setFieldValue(
//                               `permissions.${module}.view`,
//                               newValue
//                             );
//                           }
//                         });
//                       }}
//                       className="permission-checkbox"
//                     />
//                    </div>
//                   </th>
//                   <th>
//                   <div className={`checkbox_container`}>
//                   <label htmlFor=""  className="fw-normal"> Add/Edit</label>
//                     <CheckboxWrapper
//                       type="checkbox"
//                       name="masterAddEdit"
//                       checked={modules.every((module) => {
//                         if (isPermissionDisabled(module, "addEdit"))
//                           return true;
//                         return values.permissions[module].addEdit;
//                       })}
//                       onChange={(e) => {
//                         const newValue = e.target.checked;
//                         modules.forEach((module) => {
//                           if (!isPermissionDisabled(module, "addEdit")) {
//                             setFieldValue(
//                               `permissions.${module}.addEdit`,
//                               newValue
//                             );
//                           }
//                         });
//                       }}
//                       className="permission-checkbox"
//                     />
//                    </div>
//                   </th>
//                   <th>
//                     <div className={`checkbox_container`}>
//                       <label htmlFor=""  className="fw-normal"> Export</label>

//                       <CheckboxWrapper
//                         type="checkbox"
//                         name="masterExport"
//                         checked={modules.every((module) => {
//                           if (isPermissionDisabled(module, "export"))
//                             return true;
//                           return values.permissions[module].export;
//                         })}
//                         onChange={(e) => {
//                           const newValue = e.target.checked;
//                           modules.forEach((module) => {
//                             if (!isPermissionDisabled(module, "export")) {
//                               setFieldValue(
//                                 `permissions.${module}.export`,
//                                 newValue
//                               );
//                             }
//                           });
//                         }}
//                         className="permission-checkbox"
//                       />
//                     </div>
//                   </th>
//                   <th>
//                   <div className={`checkbox_container`}>
//                   <label htmlFor="" className="fw-normal"> Delete</label>
//                     <CheckboxWrapper
//                       type="checkbox"
//                       name="masterDelete"
//                       checked={modules.every((module) => {
//                         if (isPermissionDisabled(module, "delete")) return true;
//                         return values.permissions[module].delete;
//                       })}
//                       onChange={(e) => {
//                         const newValue = e.target.checked;
//                         modules.forEach((module) => {
//                           if (!isPermissionDisabled(module, "delete")) {
//                             setFieldValue(
//                               `permissions.${module}.delete`,
//                               newValue
//                             );
//                           }
//                         });
//                       }}
//                       className="permission-checkbox"
//                     />
//                    </div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {modules.map((module) => (
//                   <tr key={module}>
//                     <td className={module === "Home" ? "" : ""}>
//                       {module}
//                     </td>
//                     {["view", "addEdit", "export", "delete"].map(
//                       (permission) => (
//                         <td key={permission}>
//                           <CheckboxWrapper
//                             type="checkbox"
//                             name={`permissions.${module}.${permission}`}
//                             checked={values.permissions[module][permission]}
//                             onChange={(e) => {
//                               setFieldValue(
//                                 `permissions.${module}.${permission}`,
//                                 e.target.checked
//                               );
//                             }}
//                             className="permission-checkbox"
//                             disabled={isPermissionDisabled(module, permission)}
//                           />
//                         </td>
//                       )
//                     )}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <div className="form-actions mt-4">
//               <div>
//                 <button type="button" className="btn btn-transparent " onClick={() => onClose()}>
//                   Cancel
//                 </button>
//               </div>
//               <div className="d-flex gap-3">
//                 <div>
//                   <button
//                     type="button"
//                     className="btn btn-transparent"
//                     onClick={() =>
//                       setFieldValue("permissions", basePermissions)
//                     }
//                   >
//                     Reset
//                   </button>
//                 </div>
//                 <div>
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     disabled={isSubmitting || !dirty || !isValid}
//                   >
//                     {initialData?.role_id ? "Update Role" : "Create Role"}
//                     {isSubmitting && (
//                       <span
//                         className="spinner-border spinner-border-sm ms-2"
//                         role="status"
//                         aria-hidden="true"
//                       ></span>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default RoleManagement;




import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import InputLayout from "../../../../atoms/InputLayout";
import * as Yup from "yup";
import Error from "../../../../atoms/Error";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CheckboxWrapper from "../../../../atoms/CheckBoxWrapper/Checkbox";
import "./style.scss";
import { postData, patchData, putData, getData } from "../../../../../services";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../assets/styles/toast";
import { useSelector } from "react-redux";
import { ChevronDown, ChevronUp } from "lucide-react";

// Custom hook to access Formik context
const useFormikFieldUpdate = () => {
  const { setFieldValue } = useFormikContext();
  return { setFieldValue };
};

const RoleManagement = ({ onClose, onSubmit, initialData, refetchData }) => {
  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [permissionsData, setPermissionsData] = useState();
  const [expandedModules, setExpandedModules] = useState({});

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  // Base permissions structure with nested Reports
  const basePermissions = {
    Dashboard: { view: false, addEdit: false, export: false, delete: false },
    "Employee Management": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    "Team Management": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    Projects: { view: false, addEdit: false, export: false, delete: false },
    Tasks: { view: false, addEdit: false, export: false, delete: false },
    Reports: {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
      subModules: {
        "Client Dashboard": { view: false, addEdit: false, export: false, delete: false },
        "My DSR Report": { view: false, addEdit: false, export: false, delete: false },
        "Team DSR Report": { view: false, addEdit: false, export: false, delete: false },
      }
    },
    "Client Management": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    "Role Management": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    "Business Segment": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    "Department": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
    "Notifications": {
      view: false,
      addEdit: false,
      export: false,
      delete: false,
    },
  };

  const [initialValues, setInitialValues] = useState({
    role_Name: initialData?.role_name || "",
    permissions: basePermissions,
  });

  // Transform API data to match form structure
  const getInitialPermissions = useCallback(() => {
    if (!permissionsData || !initialData?.role_id) return basePermissions;

    const updatedPermissions = { ...basePermissions };

    permissionsData.forEach((permission) => {
      const module = permission.module;
      if (updatedPermissions[module]) {
        if (module === "Reports") {
          updatedPermissions[module] = {
            view: permission.is_view,
            addEdit: permission.is_create || permission.is_edit,
            export: permission.is_export,
            delete: permission.is_delete,
            subModules: {
              "My DSR Report": { view: false, addEdit: false, export: false, delete: false },
              "Team DSR Report": { view: false, addEdit: false, export: false, delete: false },
              "Client Dashboard": { view: false, addEdit: false, export: false, delete: false },
            }
          };
        } else {
          updatedPermissions[module] = {
            view: permission.is_view,
            addEdit: permission.is_create || permission.is_edit,
            export: permission.is_export,
            delete: permission.is_delete,
          };
        }
      }
      
      // Handle sub-modules
      if (module === "My DSR Report" && updatedPermissions.Reports) {
        updatedPermissions.Reports.subModules["My DSR Report"] = {
          view: permission.is_view,
          addEdit: permission.is_create || permission.is_edit,
          export: permission.is_export,
          delete: permission.is_delete,
        };
      }
      if (module === "Team DSR Report" && updatedPermissions.Reports) {
        updatedPermissions.Reports.subModules["Team DSR Report"] = {
          view: permission.is_view,
          addEdit: permission.is_create || permission.is_edit,
          export: permission.is_export,
          delete: permission.is_delete,
        };
      }
      if (module === "Client Dashboard" && updatedPermissions.Reports) {
        updatedPermissions.Reports.subModules["Client Dashboard"] = {
          view: permission.is_view,
          addEdit: permission.is_create || permission.is_edit,
          export: permission.is_export,
          delete: permission.is_delete,
        };
      }
    });

    return updatedPermissions;
  }, [permissionsData, initialData?.role_id]);

  useEffect(() => {
    if (permissionsData) {
      setInitialValues({
        role_Name: initialData?.role_name || "",
        permissions: getInitialPermissions(),
      });
    }
  }, [permissionsData, initialData?.role_id, getInitialPermissions]);

  const disabledPermissionsConfig = {
    Dashboard: ["export", "addEdit", "delete"],
    "Employee Management": ["export"],
    "Team Management": ["export"],
    Reports: ["addEdit", "delete", "view","export"],
    "My DSR Report": ["export"],
    "Team DSR Report": ["export"],
    "Client Dashboard": [ "delete", "addEdit"],
    "Client Management": ["export"],
    "Role Management": ["export"],
    "Business Segment": ["export"],
    "Department": ["export"],
    'Notifications': ['export', 'delete']
  };

  const isPermissionDisabled = (module, permission) => {
    return disabledPermissionsConfig[module]?.includes(permission) || false;
  };

  const modules = Object.keys(basePermissions);

  const toggleModuleExpansion = (module) => {
    setExpandedModules(prev => ({
      ...prev,
      [module]: !prev[module]
    }));
  };

  const transformPermissions = (permissions) => {
    const result = [];
    
    Object.entries(permissions).forEach(([module, perms]) => {
      if (module === "Reports") {
        // Add main Reports module
        result.push({
          module,
          create_teams: false,
          assign_task: false,
          client_dashboard_access: false,
          is_create: perms.addEdit,
          is_edit: perms.addEdit,
          is_delete: perms.delete,
          is_view: perms.view,
          is_export: perms.export,
        });
        
        // Add sub-modules
        Object.entries(perms.subModules).forEach(([subModule, subPerms]) => {
          result.push({
            module: subModule,
            create_teams: false,
            assign_task: false,
            client_dashboard_access: subModule === "Client Dashboard" ? subPerms.view : false,
            is_create: subPerms.addEdit,
            is_edit: subPerms.addEdit,
            is_delete: subPerms.delete,
            is_view: subPerms.view,
            is_export: subPerms.export,
          });
        });
      } else {
        result.push({
          module,
          create_teams: module === "TeamManagement" ? perms.addEdit : false,
          assign_task: module === "Tasks" ? perms.addEdit : false,
          client_dashboard_access: false,
          is_create: perms.addEdit,
          is_edit: perms.addEdit,
          is_delete: perms.delete,
          is_view: perms.view,
          is_export: perms.export,
        });
      }
    });
    
    return result;
  };

  const handlePermissions = useCallback(async () => {
    if (!initialData?.role_id) return;

    try {
      const res = await getData({
        endpoint: "Role/role/getAccessByRole_id",
        params: {
          roleId: initialData.role_id,
        },
        token: cookies.e_t,
      });

      if (res) {
        setPermissionsData(res?.data);
      }
    } catch (err) {
      console.error("Error fetching permissions:", err);
    }
  }, [cookies.e_t, initialData?.role_id]);

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    const transformedPermissions = transformPermissions(values.permissions);

    try {
      const res = await postData({
        endpoint: "Role/AddAccessesToRole",
        data: transformedPermissions,
        token: cookies.e_t,
        params: {
          role_name: values.role_Name,
          ...(!isAdmin && { created_by: cookies.euid }),
        },
      });

      if (res) {
        toast.success("Role created successfully", {
          style: confimationStyles,
        });
        setIsSubmitting(false);
        onClose();
        refetchData();
        onSubmit({
          role_name: values.role_Name,
          permissions: transformedPermissions,
        });
      }
    } catch (err) {
      setIsSubmitting(false);
    }
  };

  const handleFormEdit = async (values) => {
    setIsSubmitting(true);
    const transformedPermissions = transformPermissions(values.permissions);

    try {
      const res = await patchData({
        endpoint: "Role/EditAccessesToRole",
        data: transformedPermissions,
        token: cookies.e_t,
        params: {
          role_id: initialData?.role_id,
          modified_by: cookies.euid,
          role_name: values?.role_Name,
        },
      });

      if (res) {
        toast.success("Updated successfully", {
          style: confimationStyles,
        });
        setIsSubmitting(false);
        onClose();
        refetchData();
        onSubmit({
          role_name: values.role_Name,
          permissions: transformedPermissions,
        });
      }
    } catch (err) {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    handlePermissions();
  }, [handlePermissions]);

  const renderModuleRow = (module, values, setFieldValue, isSubModule = false, parentModule = null) => {
    const moduleData = isSubModule ? values.permissions[parentModule].subModules[module] : values.permissions[module];
    const hasSubModules = !isSubModule && module === "Reports" && moduleData.subModules;
    const isExpanded = expandedModules[module];
  
    return (
      <React.Fragment key={module}>
        <tr
          className={`${isSubModule ? "sub-module-row" : ""} ${hasSubModules ? "expandable-row" : ""}`}
          onClick={hasSubModules ? () => toggleModuleExpansion(module) : undefined}
          style={hasSubModules ? { cursor: 'pointer' } : {}}
        >
          <td className={`${module === "Dashboard" ? "" : ""} ${isSubModule ? "sub-module-name" : ""}`}>
            {hasSubModules && (
              <span
                className="expand-icon"
                style={{ marginRight: '8px' }}
              >
                {isExpanded ? (
                  <ChevronUp size={20} className="cursor-pointer" />
                ) : (
                  <ChevronDown size={20} className="cursor-pointer" />
                )}
              </span>
            )}
            {isSubModule}
            {module}
          </td>
          {["view", "addEdit", "export", "delete"].map((permission) => (
            <td
              key={permission}
              onClick={(e) => hasSubModules && e.stopPropagation()}
            >
              <CheckboxWrapper
                type="checkbox"
                name={isSubModule
                  ? `permissions.${parentModule}.subModules.${module}.${permission}`
                  : `permissions.${module}.${permission}`
                }
                checked={moduleData[permission]}
                onChange={(e) => {
                  const fieldPath = isSubModule
                    ? `permissions.${parentModule}.subModules.${module}.${permission}`
                    : `permissions.${module}.${permission}`;
                  setFieldValue(fieldPath, e.target.checked);
                }}
                className="permission-checkbox"
                disabled={isPermissionDisabled(module, permission)}
              />
            </td>
          ))}
        </tr>
        {hasSubModules && isExpanded &&
          Object.keys(moduleData.subModules).map(subModule =>
            renderModuleRow(subModule, values, setFieldValue, true, module)
          )
        }
      </React.Fragment>
    );
  };

  return (
    <div className="role-management-container">
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { resetForm }) => {
          if (initialData) {
            handleFormEdit(values);
          } else {
            handleFormSubmit(values, { resetForm });
          }
        }}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
      >
        {({ values, setFieldValue, errors, dirty, isValid }) => (
          <Form className="role-form">
            <div className="form-group">
              <label htmlFor="role_Name">Role</label>
              <InputLayout>
                <Field name="role_Name" />
                <Error error={errors.role_Name} />
              </InputLayout>
            </div>
            <table className="permissions-table">
              <thead>
                <tr>
                  <th>Module Name</th>
                  <th>
                    <div className="checkbox_container">
                      <label htmlFor="" className="fw-normal">View</label>
                      <CheckboxWrapper
                        type="checkbox"
                        name="masterView"
                        checked={
                          modules.every((module) => {
                            if (module === "Reports") {
                              // For Reports, only check submodules' view permissions if not disabled
                              return Object.keys(values.permissions[module].subModules).every(
                                (subModule) =>
                                  isPermissionDisabled(subModule, "view") ||
                                  values.permissions[module].subModules[subModule].view
                              );
                            } else if (!isPermissionDisabled(module, "view")) {
                              // For other modules, check view only if not disabled
                              return values.permissions[module].view;
                            }
                            return true; // Ignore modules where view is disabled
                          })
                        }
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          modules.forEach((module) => {
                            if (!isPermissionDisabled(module, "view")) {
                              setFieldValue(`permissions.${module}.view`, newValue);
                            }
                            if (module === "Reports") {
                              Object.keys(values.permissions[module].subModules).forEach(
                                (subModule) => {
                                  if (!isPermissionDisabled(subModule, "view")) {
                                    setFieldValue(
                                      `permissions.${module}.subModules.${subModule}.view`,
                                      newValue
                                    );
                                  }
                                }
                              );
                            }
                          });
                        }}
                        className="permission-checkbox"
                      />
                    </div>
                  </th>
                  <th>
                    <div className="checkbox_container">
                      <label htmlFor="" className="fw-normal">Add/Edit</label>
                      <CheckboxWrapper
                        type="checkbox"
                        name="masterAddEdit"
                        checked={modules.every((module) => {
                          if (module === "Reports") {
                            return Object.keys(values.permissions[module].subModules).every(
                              (subModule) =>
                                isPermissionDisabled(subModule, "addEdit") ||
                                values.permissions[module].subModules[subModule].addEdit
                            );
                          } else if (!isPermissionDisabled(module, "addEdit")) {
                            return values.permissions[module].addEdit;
                          }
                          return true;
                        })}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          modules.forEach((module) => {
                            if (!isPermissionDisabled(module, "addEdit")) {
                              setFieldValue(`permissions.${module}.addEdit`, newValue);
                            }
                            if (module === "Reports") {
                              Object.keys(values.permissions[module].subModules).forEach(
                                (subModule) => {
                                  if (!isPermissionDisabled(subModule, "addEdit")) {
                                    setFieldValue(
                                      `permissions.${module}.subModules.${subModule}.addEdit`,
                                      newValue
                                    );
                                  }
                                }
                              );
                            }
                          });
                        }}
                        className="permission-checkbox"
                      />
                    </div>
                  </th>
                  <th>
                    <div className="checkbox_container">
                      <label htmlFor="" className="fw-normal">Export</label>
                      <CheckboxWrapper
                        type="checkbox"
                        name="masterExport"
                        checked={modules.every((module) => {
                          if (module === "Reports") {
                            return Object.keys(values.permissions[module].subModules).every(
                              (subModule) =>
                                isPermissionDisabled(subModule, "export") ||
                                values.permissions[module].subModules[subModule].export
                            );
                          } else if (!isPermissionDisabled(module, "export")) {
                            return values.permissions[module].export;
                          }
                          return true;
                        })}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          modules.forEach((module) => {
                            if (!isPermissionDisabled(module, "export")) {
                              setFieldValue(`permissions.${module}.export`, newValue);
                            }
                            if (module === "Reports") {
                              Object.keys(values.permissions[module].subModules).forEach(
                                (subModule) => {
                                  if (!isPermissionDisabled(subModule, "export")) {
                                    setFieldValue(
                                      `permissions.${module}.subModules.${subModule}.export`,
                                      newValue
                                    );
                                  }
                                }
                              );
                            }
                          });
                        }}
                        className="permission-checkbox"
                      />
                    </div>
                  </th>
                  <th>
                    <div className="checkbox_container">
                      <label htmlFor="" className="fw-normal">Delete</label>
                      <CheckboxWrapper
                        type="checkbox"
                        name="masterDelete"
                        checked={modules.every((module) => {
                          if (module === "Reports") {
                            return Object.keys(values.permissions[module].subModules).every(
                              (subModule) =>
                                isPermissionDisabled(subModule, "delete") ||
                                values.permissions[module].subModules[subModule].delete
                            );
                          } else if (!isPermissionDisabled(module, "delete")) {
                            return values.permissions[module].delete;
                          }
                          return true;
                        })}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          modules.forEach((module) => {
                            if (!isPermissionDisabled(module, "delete")) {
                              setFieldValue(`permissions.${module}.delete`, newValue);
                            }
                            if (module === "Reports") {
                              Object.keys(values.permissions[module].subModules).forEach(
                                (subModule) => {
                                  if (!isPermissionDisabled(subModule, "delete")) {
                                    setFieldValue(
                                      `permissions.${module}.subModules.${subModule}.delete`,
                                      newValue
                                    );
                                  }
                                }
                              );
                            }
                          });
                        }}
                        className="permission-checkbox"
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {modules.map((module) => renderModuleRow(module, values, setFieldValue))}
              </tbody>
            </table>
            <div className="form-actions mt-4">
              <div>
                <button type="button" className="btn btn-transparent " onClick={() => onClose()}>
                  Cancel
                </button>
              </div>
              <div className="d-flex gap-3">
                <div>
                  <button
                    type="button"
                    className="btn btn-transparent"
                    onClick={() => setFieldValue("permissions", basePermissions)}
                  >
                    Reset
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting || !dirty || !isValid}
                  >
                    {initialData?.role_id ? "Update Role" : "Create Role"}
                    {isSubmitting && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default RoleManagement;
